<template>
  <div>
    <i-col span="24">
      <table
        v-for="(it , index) in items"
        :key="index+'tt'"
        class="left TB_COLLAPSE"
        :class="[cloce]"
        width="20%"
      >
        <thead>
          <th width="30%">{{getliveshow.title}}</th>
          <th width="70%">賠率占成</th>
        </thead>
        <tbody>
          <tr v-for="(item, key) in it" :key="key+'tc'" class="tc">
            <th :class="classColor(item.colour)">
              <h4>{{ item.name }}</h4>
            </th>
            <td :class="{'isstop0': item.isstop == 2 || item.isstop == 0 }">
              <table-adjust-odds
                :table="item"
                @go_live_show_bridge="go_live_show_bridge"
                :addbetcal="false"
              ></table-adjust-odds>
            </td>
          </tr>
        </tbody>
      </table>
    </i-col>
  </div>
</template>

<script>
import { Utile } from "utils";
import { mapGetters } from "vuex";
import checkpath from "./mixins/checkPath.js";
import liveshowSixmark from '@/mixins/liveshow-sixmark.js'
export default {
  name: "liveshow-doublecode",
  mixins: [checkpath, liveshowSixmark],
  data () {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters(["getliveshow", "getgameid"]),
    KeyName () {
      return this.liveshowPath ? "supododtwo" : "linksupododtwo";
    }
  },
  watch: {
    "getliveshow.chgbaco" (val) {
      this.getItems();
    },
    "getliveshow.reload" (val) {
      this.getItems();
    }
  },
  created () {
    // this.getItems();
  },
  methods: {
    async getItems () {
      if (!this.getliveshow.dobuecode) return
      try {
        const meta = this.$route.meta
        const obj = {
          gameid: this.getgameid,
          page: meta.page,
          odd: this.getliveshow.dobuecode,
          baco: this.getliveshow.chgbaco,
          site: this.getliveshow.siteSelect
        }
        if (this.getliveshow.siteSelect == '') {
          this.items = []
          return
        }
        const res = await this.$axios.liveshow[this.KeyName](obj);
        if ('status' in res && res.status === 0) return
        this.IsstopColor(res)
        const array = res.map(it => (it.clas = 1, it));
        this.items = Utile.chunk(array, 10);
      } catch (error) {
        console.error(error);
        console.error("liveshow_doublecode1_1_get_error了喔！");
      }
    },
    readyaxiso () {
      if (!this.$route.name.includes('doublecode')) return
      this.getItems();
    },
    go_live_show_bridge () {
      this.$emit("refresh");
    }
  }
};
</script>